import Model from 'src/storage/base';
import { notification } from 'src/helpers/notifications';

class SettingModel extends Model {
  id = 'settings';
  persistent = false;
  defaultState = () => ({
    codeLength: 5,
    showVerified: false
  });
  defaultTreatments = () => ({
    name: '',
    fee: ''
  });
  apiConfig = {
    change_pw: {
      url: 'profile/password/change',
      validation: {
        password: 'password',
        password1: 'password',
        password2: 'password'
      },
      cancellable: true
    },
    requestVerification: {
      url: 'email/request_verification',
      validation: {
        email: 'email'
      },
      cancellable: true
    },
    sendOTP: {
      url: 'phonenumber/request_verification',
      validation: {
        phoneNumber: 'phoneNumber'
      },
      cancellable: true
    },
    verifyOTP: {
      url: 'phonenumber/verify',
      validation: {
        phoneNumber: 'phoneNumber',
        code: 'required'
      },
      cancellable: true
    },
    emailSubscription: {
      url: 'email/subscription',
      validation: {},
      cancellable: true
    },
    desktopAlerts: {
      url: 'profile/set/desktopAlerts',
      validation: {},
      cancellable: true
    }
  };
  _events = {
    profile: 'handleProfile',
    location: 'initLocation',
    'notification:requestPermission': 'handleRequestPermission'
  };

  // ...existing code...

  handleRequestPermission = (perm) => {
    if (perm === 'granted') {
      if (model.state.desktopAlerts === false) {
        this.api('desktopAlerts', { value: true }, () => {
          this.setState({ desktopAlerts: true });
        });
      }
    } else {
      if (model.state.desktopAlerts !== false) {
        this.api('desktopAlerts', { value: false }, () => {
          this.setState({ desktopAlerts: false });
        });
      }
    }
  };

  initLocation = (data) => {
    this.setState({ tempCountryAddress: data.country });
  };
  handleProfile = ({ password, ...profile }) => {
    void password;
    this.reset();
    this.setState({ ...profile, user: profile });
  };

  handleChangePw = (key, value) => {
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('change_pw');
    this.handleChange(key, value);
  };

  savePw = () => {
    const id = 'change_pw';
    let req = {
      password: this.state.password,
      password1: this.state.password1,
      password2: this.state.password2
    };

    this.api(id, req, (error, data, success) => {
      if (success) {
        model.emit('logout');
      }
    });
  };

  resetPwState = () => {
    this.resetApiState('change_pw');
    this.setState({
      changed: false,
      password: '',
      password1: '',
      password2: ''
    });
  };

  requestVerification = (cb) => {
    this.api(
      'requestVerification',
      {
        email: this.state.email
      },
      cb
    );
  };
  sendOTP = (cb) => {
    this.api(
      'sendOTP',
      {
        phoneNumber: this.state.phoneNumber
      },
      cb
    );
  };

  verifyOTP = (cb) => {
    let error;
    if (!model.state.code) {
      error = 'You need to enter the code';
    }
    if (!error && model.state.code?.length !== model.state.codeLength) {
      error = 'Code is invalid';
    }

    if (error)
      return model.setInvalidApi('verifyOTP', {
        length: 1,
        code: error
      });

    this.api(
      'verifyOTP',
      {
        phoneNumber: this.state.phoneNumber,
        code: this.state.code
      },
      cb
    );
  };

  getBlock = (resetExpired) => {
    const expiredIn = (resetExpired - Date.now()) / 1000;
    const blocked = expiredIn > 0;
    return { blocked, expiredIn };
  };

  emailSubscription = () => {
    let email_subscription = model.state.email_subscription !== false;
    email_subscription = !email_subscription;

    this.api(
      'emailSubscription',
      {
        email_subscription
      },
      () => {
        this.setState({ email_subscription });
      }
    );
  };

  webpushSubscription = () => {
    notification.clearListeners();
    let desktopAlerts =
      model.state.desktopAlerts !== false && window.Notification?.permission === 'granted';
    desktopAlerts = !desktopAlerts;

    if (desktopAlerts) {
      notification.requestPermissionDirect();
    } else {
      this.api('desktopAlerts', { value: false }, () => {
        this.setState({ desktopAlerts: false });
      });
    }
  };
}

const model = new SettingModel();
export default model;
